<div [class.card-container--plain]="plain" class="card-container" [ngClass]="styleClass">
  <!-- Card skeleton -->
  <lx-card-skeleton *ngIf="loading" [bodyHeight]="skeletonHeight"></lx-card-skeleton>

  <!-- Card Content -->
  <ng-container *ngIf="!loading">
    <div class="card-container__title" *ngIf="title">
      <div
        class="card-container__title__icon"
        [class.card-container__title__icon--course]="type === 'course'"
        [class.card-container__title__icon--transfer]="type === 'transfer'"
        [class.card-container__title__icon--accommodation]="type === 'accommodation'"
        [class.card-container__title__icon--insurance]="type === 'insurance'"
        [class.card-container__title__icon--package-details]="type === 'package-details'"
        [class.card-container__title__icon--premium-activities]="type === 'premium-activities'"
        [class.card-container__title__icon--private-lesson]="type === 'private-lesson'"
        [class.card-container__title__icon--unaccompaniedMinor]="type === 'unaccompaniedMinor'"
        [class.card-container__title__icon--professional-immersion-experience]="type === 'professional-immersion-experience'"
      ></div>
      <div class="card-container__title__text">{{ title }}</div>
    </div>

    <div class="card-container__body">
      <div class="card-container__body__content">
        <ng-content></ng-content>
      </div>
      <div class="card-container__body__highlighted">
        <ng-content select=".card-container-highlighted"></ng-content>
      </div>
    </div>

    <div class="card-container__footer" *ngIf="(actionMode || price || endPrice) && footerVisible">
      <div class="card-container__footer__action" *ngIf="actionMode">
        <lx-lite-button
          [text]="buttonText"
          [icon]="buttonIcon"
          [block]="mobile$ | async"
          (buttonClick)="clickButton()"
          [lxGAClickEvent]="gaEventName"
          [attr.data-qa]="'cardContainer_button_' + actionMode"
        ></lx-lite-button>
      </div>

      <div class="card-container__footer__action" *ngIf="weeks !== undefined">
        <lx-weeks-counter [min]="0" [max]="duration" [value]="weeks" (valueChanged)="onWeeksChange($event)"></lx-weeks-counter>
      </div>

      <lx-price-label
        [price]="price"
        [endPrice]="endPrice"
        [priceLabel]="priceLabel"
        [discount]="discount"
        [disabled]="disabled"
        [currency]="currency"
      ></lx-price-label>
    </div>
  </ng-container>
</div>
